// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Award from "../domain/types/Award.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as EventUtils from "../../../library/partner-app-events/EventUtils.bs.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as RewardMilestone from "../domain/types/RewardMilestone.bs.js";
import * as RnrModalsHelper from "./helpers/RnrModalsHelper.bs.js";
import * as UrlUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as BackButtonComponent from "./BackButtonComponent.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";
import * as AwardHistoryViewMapper from "./AwardHistoryViewMapper.bs.js";
import * as PartnerAppEventsConfig from "../../../library/partner-app-events/PartnerAppEventsConfig.bs.js";
import * as RewardHistoryViewMapper from "./RewardHistoryViewMapper.bs.js";

function getHighlightClass(selectedTab, tab) {
  if (selectedTab === tab) {
    return "history-component__highlighted-navtab";
  } else {
    return "";
  }
}

function getInitialState(param) {
  return {
          showRewardModal: RnrModalsHelper.isRewardModalVisible(undefined),
          showAwardModal: RnrModalsHelper.isAwardModalVisible(undefined),
          selectedCategory: RnrModalsHelper.getRewardSelectedCategory(undefined),
          selectedDate: RnrModalsHelper.getRewardSelectedDate(undefined),
          selectedTab: RnrModalsHelper.isAwardModalVisible(undefined) ? /* Award */1 : /* Reward */0,
          milestoneToBeDisplayed: RnrModalsHelper.getMilestone(undefined)
        };
}

function RnrHistoryComponent(Props) {
  var viewModel = Props.viewModel;
  var content = Props.content;
  var match = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            if (action === /* OnCloseRewardModal */0) {
              return {
                      showRewardModal: false,
                      showAwardModal: state.showAwardModal,
                      selectedCategory: state.selectedCategory,
                      selectedDate: state.selectedDate,
                      selectedTab: state.selectedTab,
                      milestoneToBeDisplayed: state.milestoneToBeDisplayed
                    };
            } else {
              return {
                      showRewardModal: state.showRewardModal,
                      showAwardModal: false,
                      selectedCategory: state.selectedCategory,
                      selectedDate: state.selectedDate,
                      selectedTab: state.selectedTab,
                      milestoneToBeDisplayed: state.milestoneToBeDisplayed
                    };
            }
          }
          switch (action.TAG | 0) {
            case /* OnRewardHistoryRowClick */0 :
                return {
                        showRewardModal: !state.showRewardModal,
                        showAwardModal: state.showAwardModal,
                        selectedCategory: action._0,
                        selectedDate: action._1,
                        selectedTab: /* Reward */0,
                        milestoneToBeDisplayed: state.milestoneToBeDisplayed
                      };
            case /* OnAwardHistoryRowClick */1 :
                return {
                        showRewardModal: state.showRewardModal,
                        showAwardModal: !state.showAwardModal,
                        selectedCategory: state.selectedCategory,
                        selectedDate: state.selectedDate,
                        selectedTab: /* Award */1,
                        milestoneToBeDisplayed: action._0
                      };
            case /* OnTabClick */2 :
                return {
                        showRewardModal: state.showRewardModal,
                        showAwardModal: state.showAwardModal,
                        selectedCategory: state.selectedCategory,
                        selectedDate: state.selectedDate,
                        selectedTab: action._0,
                        milestoneToBeDisplayed: state.milestoneToBeDisplayed
                      };
            
          }
        }), getInitialState(undefined));
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.daily_rewards_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
          GAEvents.publishPageView("rnr/reward_history", "RnR Reward History", undefined);
          var watcherID = RescriptReactRouter.watchUrl(function (url) {
                var match = url.hash;
                switch (match) {
                  case "awards" :
                      var urlParams = UrlUtils$Catalyst.getURLParams(url.search);
                      var milestone = Js_dict.get(urlParams, "milestone");
                      var historyMilestone = milestone !== undefined ? RewardMilestone.fromUrlString(milestone) : ErrorUtils$Catalyst.raiseError("RnrHistoryComponent.re", "Invalid Milestone", "");
                      var award = RnrModalsHelper.getAward(viewModel.milestoneDetails, historyMilestone, false);
                      GAEvents.publishPageView("rnr/history/award_modal/" + Award.toString(award), "RnR History Award Modal", undefined);
                      return Curry._1(dispatch, {
                                  TAG: /* OnAwardHistoryRowClick */1,
                                  _0: historyMilestone
                                });
                  case "rewards" :
                      var urlParams$1 = UrlUtils$Catalyst.getURLParams(url.search);
                      var category = RnrModalsHelper.getCategoryFromUrl(urlParams$1);
                      var data = RnrModalsHelper.getDateFromUrl(urlParams$1);
                      var date = data !== undefined ? Caml_option.valFromOption(data) : ErrorUtils$Catalyst.raiseError("RnrHomeComponent.re", "Invalid date", "");
                      return Curry._1(dispatch, {
                                  TAG: /* OnRewardHistoryRowClick */0,
                                  _0: category,
                                  _1: Caml_option.some(date)
                                });
                  default:
                    Curry._1(dispatch, /* OnCloseRewardModal */0);
                    return Curry._1(dispatch, /* OnCloseAwardModal */1);
                }
              });
          return (function (param) {
                    RescriptReactRouter.unwatchUrl(watcherID);
                    window.scrollTo(0, 0);
                    
                  });
        }), []);
  React.useEffect((function () {
          var match = state.showRewardModal;
          if (!match) {
            var match$1 = RescriptReactRouter.dangerouslyGetInitialUrl(undefined, undefined).hash;
            if (match$1 === "rewards") {
              window.history.back();
            }
            
          }
          
        }), [state.showRewardModal]);
  var handleTabSwitch = function (selectedTab) {
    if (selectedTab) {
      EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.level_gifts_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    } else {
      EventUtils.sendEventToPartnerApp(PartnerAppEventsConfig.daily_rewards_clicked, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    var match = selectedTab ? [
        "rnr/award_history",
        "RnR Award History"
      ] : [
        "rnr/reward_history",
        "RnR Reward History"
      ];
    GAEvents.publishPageView(match[0], match[1], undefined);
    return Curry._1(dispatch, {
                TAG: /* OnTabClick */2,
                _0: selectedTab
              });
  };
  var match$1 = state.selectedTab;
  return React.createElement("div", {
              className: "history-component"
            }, React.createElement("div", {
                  className: "history-component__header"
                }, React.createElement("div", {
                      className: "history-component__title"
                    }, React.createElement(BackButtonComponent.make, {
                          className: "history-component__back-button font-size-20 u-margin-right-small"
                        }), content.rnrHistory.title), React.createElement("div", {
                      className: "u-flex__row"
                    }, React.createElement("div", {
                          className: "history-component__navtab " + getHighlightClass(state.selectedTab, /* Reward */0),
                          onClick: (function (_event) {
                              return handleTabSwitch(/* Reward */0);
                            })
                        }, content.rnrHistory.rewardNavTabTitle), React.createElement("div", {
                          className: "history-component__navtab " + getHighlightClass(state.selectedTab, /* Award */1),
                          onClick: (function (_event) {
                              return handleTabSwitch(/* Award */1);
                            })
                        }, content.rnrHistory.awardNavTabTitle))), match$1 ? AwardHistoryViewMapper.AwardHistoryViewMapper.getView(viewModel, content, state.showAwardModal, state.milestoneToBeDisplayed) : RewardHistoryViewMapper.RewardHistoryViewMapper.getView(viewModel, content, state.showRewardModal, state.selectedDate, state.selectedCategory, (function (category, date) {
                      return Curry._1(dispatch, {
                                  TAG: /* OnRewardHistoryRowClick */0,
                                  _0: category,
                                  _1: date
                                });
                    })));
}

var make = RnrHistoryComponent;

export {
  getHighlightClass ,
  getInitialState ,
  make ,
  
}
/* react Not a pure module */
